// 실시간 WebSocket 클라이언트 — 서버의 변경 알림을 수신해 콜백을 호출한다.
// 세션 쿠키는 동일 오리진 WS 핸드셰이크에 자동 포함된다. 끊기면 지수 백오프로 재연결.
export function connectRealtime(onMessage, onStatus) {
  let ws = null;
  let closed = false;
  let retry = 0;
  let timer = null;
  const status = (up) => { if (onStatus) onStatus(up); };

  const url = () => {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${proto}://${window.location.host}/ws`;
  };

  function open() {
    if (closed) return;
    try {
      ws = new WebSocket(url());
    } catch (e) {
      schedule();
      return;
    }
    ws.onopen = () => { retry = 0; status(true); };
    ws.onmessage = (ev) => {
      let data;
      try { data = JSON.parse(ev.data); } catch { return; }
      onMessage(data);
    };
    ws.onclose = () => { ws = null; status(false); schedule(); };
    ws.onerror = () => { try { ws && ws.close(); } catch { /* noop */ } };
  }

  function schedule() {
    if (closed || timer) return;
    const delay = Math.min(30000, 1000 * 2 ** retry); // 1s → 2s → … → 30s
    retry += 1;
    timer = setTimeout(() => { timer = null; open(); }, delay);
  }

  open();

  return {
    close() {
      closed = true;
      if (timer) { clearTimeout(timer); timer = null; }
      if (ws) { try { ws.close(); } catch { /* noop */ } }
    },
  };
}
